import Alert from "@mui/material/Alert";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import Stack from "@mui/material/Stack";
import { Note } from "../../../components/primitives/data-display/Note";
import { Section } from "../../../components/primitives/layout/Section";
import { gaps } from "../../../components/primitives/spacing";
import type { CorpusScanPanelProps } from "./corpus_scan_contract";

/** The standard layout of a selected scan: its title and short description, its own fields, the one
 *  button that runs it, then the error or the results. Every scan is drawn through it. */
export function CorpusScanPanel({
  title,
  description,
  fields,
  runLabel,
  onRun,
  running,
  error,
  results,
}: CorpusScanPanelProps) {
  return (
    <Section title={title} gap={gaps.base}>
      <Note>{description}</Note>
      <Stack direction="row" gap={gaps.snug} alignItems="center" flexWrap="wrap">
        {fields}
        <Button
          variant="contained"
          onClick={onRun}
          disabled={running}
          startIcon={running ? <CircularProgress size={16} color="inherit" /> : undefined}
        >
          {runLabel}
        </Button>
      </Stack>
      {error ? <Alert severity="error">{error}</Alert> : null}
      {results}
    </Section>
  );
}
